export default __webpack_public_path__ + "static/media/strasbourg6.e80fbdd2.jpg";